import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useMemo, useState } from "react";

export const FRASE_CONFIRMACAO_ARQUIVO = "sim, esse é o arquivo correto";

const normalizar = (texto) =>
  (texto || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();

function ConfirmacaoDigitandoModal({
  open,
  onClose,
  onConfirm,
  tipoDocumento = "Boleto",
  loading = false,
}) {
  const [digitado, setDigitado] = useState("");

  useEffect(() => {
    if (!open) setDigitado("");
  }, [open]);

  const confirmado = useMemo(
    () => normalizar(digitado) === normalizar(FRASE_CONFIRMACAO_ARQUIVO),
    [digitado],
  );

  const handleConfirm = () => {
    if (!confirmado || loading) return;
    onConfirm?.();
  };

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Confirmar envio do documento</DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          Você tem certeza que esse documento selecionado é o{" "}
          <strong>{tipoDocumento}</strong> correto?
        </Alert>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
          Para confirmar, digite exatamente:{" "}
          <strong>{FRASE_CONFIRMACAO_ARQUIVO}</strong>
        </Typography>
        <TextField
          fullWidth
          autoFocus
          label="Confirmação"
          value={digitado}
          onChange={(e) => setDigitado(e.target.value)}
          disabled={loading}
          placeholder={FRASE_CONFIRMACAO_ARQUIVO}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleConfirm}
          disabled={!confirmado || loading}
        >
          {loading ? "Enviando..." : "Confirmar e Enviar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmacaoDigitandoModal;
